import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var LassoSelect = createReactComponent("LassoSelect", ["svg", defaultAttributes, [["path", {
  d: "M7 22a5 5 0 01-2-4",
  key: "16rap9"
}], ["path", {
  d: "M7 16.93c.96.43 1.96.74 2.99.91",
  key: "1ljl7n"
}], ["path", {
  d: "M3.34 14A6.8 6.8 0 012 10c0-4.42 4.48-8 10-8s10 3.58 10 8a7.19 7.19 0 01-.33 2",
  key: "119roj"
}], ["path", {
  d: "M5 18a2 2 0 100-4 2 2 0 000 4z",
  key: "1rvba9"
}], ["path", {
  d: "M14.33 22h-.09a.35.35 0 01-.24-.32v-10a.34.34 0 01.33-.34c.08 0 .15.03.21.08l7.34 6a.33.33 0 01-.21.59h-4.49l-2.57 3.85a.35.35 0 01-.28.14v0z",
  key: "vwv8lq"
}]]]);
export default LassoSelect;